import Spacer from 'components/gruenland/organisms/spacer';

const YggdrasilSpacerTastic = () => {
  return <Spacer />;
};

export default YggdrasilSpacerTastic;
